import React from 'react';
// The caption field is removed according to FY-10286, to be readded in FY-10290
import FileUpload, {
  UPLOAD_FILE_TYPES,
} from 'legacy/src/components/content/controls/FileUpload';
import media from 'legacy/src/components/content/types/media/image';

import './image.scss';

export const IMAGE_FILE_EXTENSIONS = ['jpeg', 'png', 'jpg', 'gif'];
const Image = ({ cursor }) => {
  const contentCursor = cursor.sub(['content']);

  const getProcessedURL = (result, etag) => {
    const contentType = result.content_type.split('/')[1].replace(/\+.+$/, '');
    const suffix = contentType === 'jpeg' ? 'jpg' : contentType;
    const path = `${etag}/original.${suffix}`;
    return `${S3_MEDIA_URL}${path}`;
  };

  const onProcessed = (result, etag) => {
    contentCursor.requestChange({
      ...contentCursor.value,
      src: getProcessedURL(result, etag),
    });
  };

  return (
    <div>
      <div className="types-image__options">
        <div className="image_upload">
          <FileUpload
            fileType={UPLOAD_FILE_TYPES.IMAGE}
            allowedFileExtensions={IMAGE_FILE_EXTENSIONS}
            getProcessedURL={getProcessedURL}
            onProcessed={onProcessed}
          />
        </div>

        <p>Max Width</p>
        <select
          value={contentCursor.sub(['maxWidth']).value}
          onChange={(e) =>
            contentCursor.sub(['maxWidth']).requestChange(e.target.value)
          }
        >
          <option value="">Auto</option>
          <option value="100">Thumbnail</option>
          <option value="200">Small</option>
          <option value="400">Medium</option>
          <option value="800">Large</option>
        </select>

        <p>Alt text:</p>
        <input
          value={contentCursor.sub(['alt']).value}
          onChange={(e) =>
            contentCursor.sub(['alt']).requestChange(e.target.value)
          }
        />

        {/* The caption field is removed according to FY-10286, to be readded in FY-10290 */}
        <p>Caption:</p>
        <input
          value={contentCursor.sub(['caption']).value}
          onChange={(e) =>
            contentCursor.sub(['caption']).requestChange(e.target.value)
          }
        />
      </div>
      <div className="types-image__preview">
        <p>Preview:</p>
        {contentCursor.value.src && (
          <media.Player
            className="image"
            item={{ content: contentCursor.value }}
          />
        )}
      </div>
    </div>
  );
};

export default Image;
